const TABLE_INJECTION_KEY = Symbol("ElTable");

export { TABLE_INJECTION_KEY };
//# sourceMappingURL=tokens.mjs.map
